import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { balanceKeys } from './balance';
import { dashboardKeys } from './dashboard';
import { loanKeys } from './loan';
import { paymentKeys } from './payment';
import { policyKeys } from './policy';
import { memberKeys } from './user';

/**
 * Policies, payments, loans, balances, members and the dashboard all read from the same
 * numbers, so any write to one of them refreshes all of them.
 */
export function useRefreshPolicyData() {
  const queryClient = useQueryClient();

  return useCallback(
    () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: paymentKeys.all }),
        queryClient.invalidateQueries({ queryKey: policyKeys.all }),
        queryClient.invalidateQueries({ queryKey: loanKeys.all }),
        queryClient.invalidateQueries({ queryKey: memberKeys.all }),
        queryClient.invalidateQueries({ queryKey: balanceKeys.all }),
        queryClient.invalidateQueries({ queryKey: dashboardKeys.all }),
      ]),
    [queryClient]
  );
}
